import { b as n, r as s } from "./export-cdcbfb2b.js";
import { t as c } from "./to-string-92a62764.js";
var o = `	
\v\f\r                　\u2028\u2029\uFEFF`, v = n, p = s, m = c, e = o, i = v("".replace), f = RegExp("^[" + e + "]+"), g = RegExp("(^|[^" + e + "])[" + e + "]+$"), u = function(t) {
  return function(a) {
    var r = m(p(a));
    return t & 1 && (r = i(r, f, "")), t & 2 && (r = i(r, g, "$1")), r;
  };
}, l = {
  // `String.prototype.{ trimLeft, trimStart }` methods
  // https://tc39.es/ecma262/#sec-string.prototype.trimstart
  start: u(1),
  // `String.prototype.{ trimRight, trimEnd }` methods
  // https://tc39.es/ecma262/#sec-string.prototype.trimend
  end: u(2),
  // `String.prototype.trim` method
  // https://tc39.es/ecma262/#sec-string.prototype.trim
  trim: u(3)
};
export {
  l as s,
  o as w
};
